import { useEffect, useState } from 'react';

import { apiFetchRaw } from '@/services/api';

/**
 * <img> que não quebra em silêncio.
 *
 * Teste humano 03/09: a capa do artigo #147 vinha do WP da POC em
 * `http://179.197.66.166:8085/...` e o painel roda em https — o navegador
 * bloqueia conteúdo misto e mostra o ícone quebrado, sem dizer por quê.
 *
 * - URL http numa página https → busca a imagem pelo backend
 *   (`GET /media/proxy`, autenticado, só o WP da marca) e mostra via blob.
 * - Qualquer falha (404, proxy recusou, rede) → placeholder com a URL, para o
 *   operador ver o que falhou em vez de um quadrado vazio.
 */
export function SafeImg({
  src,
  site,
  alt = '',
  className,
  placeholderClassName,
}: {
  src: string;
  /** slug da marca (define QUAL WP o proxy pode ler); vazio = 1ª do tenant */
  site?: string;
  alt?: string;
  className?: string;
  placeholderClassName?: string;
}) {
  const [resolved, setResolved] = useState<string | null>(precisaProxy(src) ? null : src);
  const [falhou, setFalhou] = useState(false);

  useEffect(() => {
    setFalhou(false);
    if (!precisaProxy(src)) {
      setResolved(src);
      return;
    }
    let objectUrl: string | null = null;
    let cancelado = false;
    const qs = new URLSearchParams({ url: src });
    if (site) qs.set('site', site);
    apiFetchRaw(`/media/proxy?${qs}`)
      .then((r) => r.blob())
      .then((b) => {
        if (cancelado) return;
        objectUrl = URL.createObjectURL(b);
        setResolved(objectUrl);
      })
      .catch(() => {
        if (!cancelado) setFalhou(true);
      });
    return () => {
      cancelado = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src, site]);

  if (falhou) {
    return (
      <div className={placeholderClassName} title={src}>
        imagem indisponível
        <br />
        <small style={{ wordBreak: 'break-all', opacity: 0.7 }}>{src}</small>
      </div>
    );
  }
  if (!resolved) {
    return <div className={placeholderClassName}>carregando imagem…</div>;
  }
  return <img src={resolved} alt={alt} className={className} onError={() => setFalhou(true)} />;
}

/** http:// numa página https:// = conteúdo misto; o navegador bloqueia. */
function precisaProxy(url: string): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.protocol === 'https:' && url.startsWith('http://');
}
